/* =====================================================================
   Mike Beau Monde — Site JavaScript
   ===================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Sticky Header — CSS: .mbm-header.is-scrolled
  ------------------------------------------------------------------ */
  var header = document.querySelector('.mbm-header');
  if (header) {
    function updateHeader() {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ------------------------------------------------------------------
     Mobile Drawer — CSS: .mbm-drawer.is-open
  ------------------------------------------------------------------ */
  var drawerToggle = document.querySelector('.mbm-nav-toggle');
  var drawer = document.querySelector('.mbm-drawer');
  var drawerClose = document.querySelector('.mbm-drawer__close');
  var drawerBackdrop = document.querySelector('.mbm-drawer__backdrop');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.add('is-open');
    document.body.classList.add('mbm-no-scroll');
    drawer.setAttribute('aria-hidden', 'false');
    if (drawerClose) drawerClose.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.remove('is-open');
    document.body.classList.remove('mbm-no-scroll');
    drawer.setAttribute('aria-hidden', 'true');
    if (drawerToggle) drawerToggle.focus();
  }

  if (drawerToggle) drawerToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ------------------------------------------------------------------
     Reveal Animations — CSS: .mbm [data-reveal].is-visible
  ------------------------------------------------------------------ */
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.mbm [data-reveal]');
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });

    /* Stagger containers — CSS: .mbm .reveal-stagger.is-visible */
    var staggerEls = document.querySelectorAll('.mbm .reveal-stagger');
    var staggerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            staggerObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    staggerEls.forEach(function (el) { staggerObserver.observe(el); });
  } else {
    document.querySelectorAll('.mbm [data-reveal], .mbm .reveal-stagger').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ------------------------------------------------------------------
     Blog Tabs — CSS: .tabs__btn.is-active
  ------------------------------------------------------------------ */
  var tabBtns = document.querySelectorAll('.mbm .tabs__btn[data-filter]');
  var blogCards = document.querySelectorAll('.mbm .blog-card');

  if (tabBtns.length > 0) {
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.dataset.filter;

        document.querySelectorAll('.mbm .tabs__btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        blogCards.forEach(function (card) {
          var cats = (card.dataset.category || '').split(' ');
          if (filter === 'all' || cats.indexOf(filter) !== -1) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Reading Progress Bar
  ------------------------------------------------------------------ */
  var progressBar = document.querySelector('.mbm-reading-progress');
  if (progressBar) {
    window.addEventListener('scroll', function () {
      var docH = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      progressBar.style.width = (window.scrollY / docH * 100) + '%';
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Sticky Sidebar Scrollspy
  ------------------------------------------------------------------ */
  var stickySidebar = document.querySelector('.mbm-sticky-sidebar');
  if (stickySidebar) {
    var sidebarLinks = stickySidebar.querySelectorAll('a[href^="#"]');
    var sections = [];
    sidebarLinks.forEach(function (link) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) sections.push({ el: target, link: link });
    });
    if (sections.length > 0) {
      window.addEventListener('scroll', function () {
        var current = sections[0];
        sections.forEach(function (s) {
          if (window.scrollY >= s.el.offsetTop - 120) current = s;
        });
        sidebarLinks.forEach(function (l) { l.classList.remove('is-active'); });
        if (current) current.link.classList.add('is-active');
      }, { passive: true });
    }
  }

  /* ------------------------------------------------------------------
     FAQ Accordion
  ------------------------------------------------------------------ */
  document.querySelectorAll('.mbm-faq__item').forEach(function (item) {
    var question = item.querySelector('.mbm-faq__question');
    var answer = item.querySelector('.mbm-faq__answer');
    if (!question || !answer) return;
    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.mbm-faq__item').forEach(function (i) {
        i.classList.remove('is-open');
        var a = i.querySelector('.mbm-faq__answer');
        if (a) a.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ------------------------------------------------------------------
     YouTube Facade
  ------------------------------------------------------------------ */
  document.querySelectorAll('.mbm-yt-facade').forEach(function (facade) {
    facade.addEventListener('click', function () {
      var videoId = facade.dataset.videoId;
      if (!videoId) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.width = '100%';
      iframe.height = '100%';
      facade.replaceWith(iframe);
    });
  });

})();
